<script>
import { CellGroup, Cell } from 'vant'
import ImageViewer from '@/fcl/components/user/ImageViewer'
import BottomToolbar from '@/fcl/components/user/BottomToolbar'
import { QNImageUtil } from '@/fcl/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-referee-detail',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell-group': CellGroup,
        'van-cell': Cell,
        'image-viewer': ImageViewer,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            referee: {
                id: null,
                organizationId: null,
                name: null,
                avatarUrl: null,
                genderLabel: null,
                phone: null,
                sportTypeLabel: null,
                gradeLabel: null,
                credentialNum: null,
                enabledLabel: null,
                isInvited: null,
                roleLabel: null,
            },
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        operatorIconButtons() {
            console.log('operatorIconButtons', this.referee.isLogon, this.referee.role)
            const iconButtons = []
            if (!this.referee.isInvited) {
                iconButtons.push({ type: 'invite-referee', iconType: 'vant', icon: 'wechat', label: this.locale['invite'] })
            }
            iconButtons.push({ type: 'edit-referee', iconType: 'vant', icon: 'edit', label: this.locale['edit'] })
            return iconButtons
        },
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onBottomToolbarIconClick(type) {
            if (type == 'invite-referee') {
                this.onInviteBtnClick()
            }
            else if (type == 'edit-referee') {
                this.onEditBtnClick()
            }
        },
        onInviteBtnClick() {
            console.log('onInviteBtnClick')
            this.$emit('custom-event', {
                type: 'invite-referee',
                data: {
                    id: this.referee.id,
                    organizationId: this.organizationId,
                    name: this.referee.name,
                    roleLabel: this.referee.roleLabel
                }
            })
        },
        onEditBtnClick() {
            console.log('onEditBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'UserOrgEditReferee',
                    params: { id: this.referee.id },
                    query: {
                        organizationId: this.organizationId
                    }
                }
            })
        },
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
    },
}
</script>

<template>
    <div class="referee-detail">
        <van-cell-group>
            <van-cell :title="locale['referee-name-label']" :value="referee.name"/>
            <image-viewer
                :label="locale['referee-avatar']"
                :imageUrl="adjustImageSize(referee.avatarUrl, 160, 160)"
                :previewImageUrl="adjustImageSize(referee.avatarUrl, 750, 750)"
            />
            <van-cell :title="locale['gender']" :value="referee.genderLabel"/>
            <van-cell :title="locale['referee-phone']" :value="referee.phone"/>
            <van-cell :title="locale['referee-sport-type-label']" :value="referee.sportTypeLabel"/>
            <van-cell :title="locale['referee-grade']" :value="referee.gradeLabel"/>
            <van-cell :title="locale['referee-credential-num-label']" :value="referee.credentialNum"/>
            <van-cell :title="locale['referee-status-label']" :value="referee.enabledLabel"/>
        </van-cell-group>
        <bottom-toolbar
            type="icons"
            :mainIcons="operatorIconButtons"
            @click-main-icon="onBottomToolbarIconClick"
        />
    </div>
</template>